import React, { useState } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { TbCalendarMonth, TbShare, TbUser } from "react-icons/tb";
import "./SHAnnouncementDetailPage.css";

export default function SHAnnouncementDetailPage({
  announcement,
  setSelectedAnnouncement,
}) {
  const [isImageZoomOpen, setIsImageZoomOpen] = useState(false);
  // createdDateTime, API'den saniye cinsinden Unix timestamp olarak geliyor.
  // Bunu milisaniyeye çevirip Date objesi oluşturuyoruz:
  const timestampMs = Number(announcement.createdDateTime) * 1000;
  const dateObj = new Date(timestampMs);
  // Örneğin "DD.MM.YYYY" formatında göstermek için:
  const formattedDate = dateObj.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <div>
      <div
        className="sh-info-header-actions"
        style={{ marginTop: "15px", marginBottom: "15px" }}
      >
        {/* <button className="kronos-add-manual-button" style={{ gap: "10px" }}>
          <TbShare style={{ marginTop: "3px" }} />
          Share
        </button> */}

        <button
          onClick={() => setSelectedAnnouncement(null)}
          className="kronos-add-manual-button"
          style={{ width: "34px", height: "34px", padding: 0 }}
        >
          <FaChevronLeft />
        </button>
      </div>

      <div className="sh-info-main">
        <div style={{ flexDirection: "row", display: "flex", gap: "15px" }}>
          <div className="sh-image-wrapper" style={{ padding: 0 }}>
            <img
              src={announcement.image}
              alt={announcement.title}
              className="sh-card-image"
              style={{ cursor: 'zoom-in' }}
              onClick={() => setIsImageZoomOpen(true)}
            />
            <span className="sh-event-card-date-badge">
              {announcement.type}
            </span>
          </div>

          <div>
            <h1 className="sh-event-title">{announcement.title}</h1>
            <p className="sh-location">{announcement.subTitle}</p>

            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <TbUser className="sh-announcement-detail-info" />
              <span className="sh-announcement-detail-info">
                {announcement.createdBy.name+" "+announcement.createdBy.lastname}
              </span>
            </div>

            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <TbCalendarMonth className="sh-announcement-detail-info" />
              <span className="sh-announcement-detail-info">
                {formattedDate}
              </span>
            </div>
          </div>
        </div>

        <p className="sh-info-description" style={{ marginTop: "15px" }}>
          {announcement.description}
        </p>
      {isImageZoomOpen && (
        <div className="sh-image-zoom-overlay" onClick={() => setIsImageZoomOpen(false)}>
          <div className="sh-image-zoom-content">
            <img src={announcement.image} alt={announcement.title} />
          </div>
        </div>
      )}
      </div>
    </div>
  );
}
